<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-lg">
          <div class="page-links">
            <router-link to="/safari/calculation" class="page-links__item">Calculation Setting</router-link>
            <router-link to="/safari/parks" class="page-links__item is-active">National Parks</router-link>
          </div>
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="national-parks" v-if="isLoad">
            <div class="page-title">
              <h2>Safari | National Parks</h2>
              <div class="page-title__side">
                <div class="form-control-wrap">
                  <input type="text" placeholder="Search" v-model="search" class="form-control-search"/>
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-search ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </div>
                </div>
                <router-link to="/safari/parks/add" class="btn btn--green"><span>Add Park</span></router-link>
              </div>
            </div>
            <div data-simplebar="data-simplebar" class="national-parks__table-wrap">
              <div class="national-parks__table">
                <div class="national-parks__table__head">
                  <div class="col col-country"><span>Country</span></div>
                  <div class="col col-name"><span>Park Name for Client</span></div>
                  <div class="col col-name-calc"><span>Park Name for Calculator</span></div>
                  <div class="col col-created"><span>Created</span></div>
                  <div class="col col-update"><span>Last Update</span></div>
                </div>
                <router-link class="national-parks__table__row" v-for="(item, index) in parks" :key="item.id"
                             :to="'/safari/parks/' + item.id">
                  <div class="col col-country"><span>{{ item.country ? item.country.name : '—' }}</span></div>
                  <div class="col col-name"><span>{{ item.nameForClient }}</span></div>
                  <div class="col col-name-calc"><span>{{ item.nameForSystem }}</span></div>
                  <div class="col col-created"><span>{{ item.createdAt }}</span></div>
                  <div class="col col-update"><span>{{ item.updatedAt }}</span></div>
                  <div class="col col-action">
                    <button type="button" class="national-parks__table__dropdown-trigger"
                            @click.stop.prevent="parks = parks.map(park => park.id === item.id ? {...park, menu: !park.menu} : {...park, menu: false})">
                      <svg width="1em" height="1em" class="icon icon-more ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                      </svg>
                      <div :class="['edit-popup edit-popup--short', { 'toup' : index + 1 === parks.length } ]"
                           v-if="item.menu">
                        <div class="form-control-group">
                          <button type="button" class="btn form-control-action"
                                  @click="$router.push('/safari/parks/' + item.id)"><span
                              class="form-control-action__icon icon--green">
                                        <svg width="1em" height="1em" class="icon icon-edit ">
                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                                        </svg></span><span class="form-control-action__text">Edit</span></button>
                        </div>
                        <div class="form-control-group">
                          <button type="button" class="btn form-control-action" @click="$emit('deleteModalHandler', {
                                            entity: 'National Park',
                                            name: item.name,
                                            handler: deleteParkHandler,
                                            id: item.id
                                        })"><span
                              class="form-control-action__icon icon--red">
                                        <svg width="1em" height="1em" class="icon icon-close ">
                                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                        </svg></span><span class="form-control-action__text">Delete</span></button>
                        </div>
                      </div>
                    </button>
                  </div>
                </router-link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

import {getParks, deletePark} from '@/utilites/api'

export default {
  props: ['user'],
  data() {
    return {
      search: '',
      parks: [],
      parksData: [],
      isLoad: false
    }
  },
  methods: {
    updateData() {
      this.isLoad = false
      getParks(this.user.access_token)
          .then(res => {
            this.isLoad = true
            this.parks = res.map(item => ({...item, menu: false}))
            this.parksData = res.map(item => ({...item, menu: false}))
          })
    },
    deleteParkHandler(id) {
      deletePark(this.user.access_token, id)
          .then(res => {
            this.updateData()
            this.$emit('confirmed')
          })
    }
  },
  beforeCreate() {
    document.title = 'Safari / National Parks'
  },
  mounted() {
    document.title = 'Safari / National Parks'
    this.updateData()
    window.addEventListener('click', event => {
      if (!event.target.closest('.national-parks__table__dropdown-trigger')) {
        this.parks = this.parks.map(item => ({...item, menu: false}))
      }
    })
  },
  watch: {
    search() {
      if (this.search.length === 0) {
        this.parks = this.parksData
      }
      let filtered = this.parksData.filter(item => this.search.length ? (item.nameForClient && item.nameForClient.toLowerCase().includes(this.search.toLowerCase())) ? item : false : item)
      this.parks = filtered
    }
  }
}
</script>

<style scoped lang="scss">
.national-parks__table {
  .col-country {
    width: 12rem;
    flex-shrink: 0;
    padding: 0 1.4rem;
    justify-content: flex-start;
    text-align: left;
  }

  .col-name,
  .col-name-calc {
    width: auto;
    min-width: 0;
    flex: 1 1 0;
    padding: 0 1.4rem;
    justify-content: flex-start;
    text-align: left;
  }

  .col-country span,
  .col-name-calc span {
    display: block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .col-created,
  .col-update {
    margin-right: 0;
  }
}

.national-parks__table__head {
  .col-country,
  .col-name-calc {
    color: #1a1a1a;
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 1em;
  }
}

.national-parks__table__row {
  .col-country,
  .col-name-calc {
    color: #606060;
    font-size: 1.2rem;
    line-height: 1em;
  }
}
</style>
